<swiper class="lobby_game--themes mySwiper swiper-control clearfix" [config]="swiperTagConfig">
    <ng-template *ngFor="let tagKey of tagsList" swiperSlide>
        <div class="lobby_game--theme" 
        [ngClass]="{'active': activeTag === tagKey}" 
        (click)="goToCategoryTag(tagKey)">
        <span>{{'gamePlayCategories.'+tagKey | translate}}</span>
    </div>
    </ng-template>
</swiper>